import { Injectable,EventEmitter } from '@angular/core';


export interface IBreadCrumb {
  id: number;
  header?: string;
  label?: string;
  command?: Function;
  active?: boolean;
  sortOrder?: number;
}

export class BreadCrumb {
  public id: number;
  public header: string;
  public label: string;
  public command: Function;
  public active: boolean;
  public sortOrder: number;
  public activeCalc: Function;

  constructor(options: IBreadCrumb) {
    this.id = options.id != undefined && options.id != null ? options.id : 0;
    this.header = options.header != undefined && options.header != null ? options.header : '';
    this.label = options.label != undefined && options.label != null ? options.label : '';
    this.command = options.command;
    this.active = options.active;
    this.sortOrder = options.sortOrder
  }
}

@Injectable({
  providedIn: 'root'
})
export class BreadCrumbsService {
  public onHeader: boolean = false; 
  public breadcrumbs: BreadCrumb[] = new Array<BreadCrumb>();
  public onNavigateBack: EventEmitter<string> = new EventEmitter<string>();
  public navigating: boolean = false;
  constructor() { }



public navigateBack(){
  this.onNavigateBack.emit('');
}
}
